import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../../../components/Button";
import DataTableMui from "../../../../components/DataTableMui";
import PageLoader from "../../../../components/PageLoader";
import { getFranchise } from "../../../../services/beneficiario/tabelaFranquia";
import * as S from './styles';

function TabelaFranquia({ location: { dataBeneficiario } }) {
    const [dataTable, setDataTable] = useState([]);
    const [isAlreadySearched, setIsAlreadySearched] = useState(false);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    async function loadData() {
        setLoading(true);
        setIsAlreadySearched(false)

        const carteirinha = { carteirinha: dataBeneficiario.numCarteira };
        let data = [];

        try {
            data = (await getFranchise(carteirinha)) || [];
        } catch (error) {
            setDataTable([]);
        } finally {
            const treatedData = data.map((element) => ({
                descricaoGrupo: element.descricaoGrupo,
                codigoProcedimento: element.codigoProcedimento,
                descricaoProcedimento: element.descricaoProcedimento,
                valorFranquia: element.valorFranquia
            }));

            setDataTable(treatedData);
        }

        setLoading(false);
        setIsAlreadySearched(true);
    }

    useEffect(() => {
        loadData();
    }, []);

    const emptyMessage = 'Não foi possível gerar a tabela de franquia, por gentileza entrar em contato com a NDI.';

    const columnsHead = [
        {
            key: 'descricaoGrupo',
            selector: (row) => row.descricaoGrupo || '-',
            name: 'Grupo de procedimento',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '100px' }),
        },
        {
            key: 'codProdecimento',
            selector: (row) => row.codigoProcedimento || '-',
            name: 'Código de procedimento',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '100px' }),
        },
        {
            key: 'descricao',
            selector: (row) => row.descricaoProcedimento || '-',
            name: 'Descrição',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px', height: '60px' }),
        },
        {
            key: 'valor',
            selector: (row) => row.valorFranquia || '-',
            name: 'Valor',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
    ];

    return (
        <>
            <S.PageContainer>
                <S.Tittle>Grupo de procedimentos</S.Tittle>
                <DataTableMui
                    data={dataTable}
                    columns={columnsHead}
                    alreadySearched={isAlreadySearched}
                    emptyMessage={emptyMessage}
                />
                <PageLoader loading={loading} />
                <S.ButtonContainer>
                    <Button onClick={() => history.goBack()}>
                        Voltar
                    </Button>
                </S.ButtonContainer>
            </S.PageContainer>
        </>
    );
};

export default TabelaFranquia;